import moment from "moment";

// Function to convert Date to ISO format
export function convertToISOFormat(dateString) {
  // Parse the input date string into a Date object
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    console.error("Invalid date string");
    return;
  }

  // Extract components for the ISO format
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // Format the date in 'YYYY-MM-DDTHH:mm' format
  const isoFormattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

  return isoFormattedDate;
}

//a function which converts UTC to local time of user
export const convertUTCToLocal = (utcDate) => {
  const isoFormattedDate = convertToISOFormat(utcDate); //first convert in ISO format
  return moment.utc(isoFormattedDate).local().format("D MMM YYYY, hh:mm a"); // Convert UTC to local time
};

//make number comma seperated according to international number system
export const convertCommaSeperateNumToString = (num, showDecimal) => {
  if (showDecimal) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  } else {
    return new Intl.NumberFormat("en-US").format(Number(num).toFixed(2));
  }
};

//A function to get future date by passing the year to add
export const getFutureDate = (yearsToAdd) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + yearsToAdd);

  return date.toLocaleDateString("en-CA"); // Outputs YYYY-MM-DD in local time
};

// * Rounds a number to 2 decimal places, rounding up only when the 3rd decimal digit is 5 or more.
// * Example: 3.451 => 3.45,3.458 => 3.46, 3.4 => 3.40
export const roundUpToTwoDecimals = (value) => {
  return Number((Math.ceil(value * 1000) / 1000).toFixed(2));
};
